export const MUST_LAST_NODE = 'output'
export const MUST_LAST_NODE_NAME = '结果输出'

export const filtersCondition = {
  condition: 'and', // 默认条件组内部为"且"关系
  filters: [
    {
      key: undefined,
      compare: undefined,
      value: undefined
    }
  ]
}

export const defaultValueFilters = [
  filtersCondition
]

export const defaultValueCombineFilters = {
  condition: 'or', // 默认条件组之间为"或"关系，固定值
  filters: defaultValueFilters
}